import { Node } from '@tiptap/core'
import { omit } from 'es-toolkit/object'

export interface IframeOptions {
  allowFullscreen: boolean
  HTMLAttributes: {
    [key: string]: any
  }
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    iframe: {
      /**
       * Add an iframe
       */
      setIframe: (options: { src: string }) => ReturnType
      /**
       * AddS an iframe
       */
      setIframeWidth: (options: { width: string }) => ReturnType
    }
  }
}

export const Iframe = Node.create<IframeOptions>({
  name: 'iframe',
  group: 'block',
  draggable: true,
  // atom: true,

  addOptions() {
    return {
      allowFullscreen: true,
      HTMLAttributes: {
        // class: 'iframe-wrapper'
      }
    }
  },

  addAttributes() {
    return {
      customWidth: {
        default: 90,
        parseHTML: element => {
          // console.log('iframe addAttributes parseHtml element: ', element)

          const dataCustomWidth = element.getAttribute('data-custom-width')

          if (dataCustomWidth) {
            // console.log('iframe parseHTML dataCustomWidth: ', dataCustomWidth)
            return dataCustomWidth
          }

          const getWidth = element?.parentElement?.parentElement?.style?.width

          if (getWidth) {
            // console.log('iframe parseHTML getWidth: ', getWidth)
            return getWidth?.replace('%', '')
          }

          return 90
        },
        renderHTML: attributes => {
          // console.log('iframe customWidth renderHTML - attributes: ', attributes)
          return {
            'data-custom-width': attributes?.customWidth,
            customWidth: attributes?.customWidth
          }
        }
      },
      src: {
        default: null
      },
      frameborder: {
        default: 0
      },
      // allowfullscreen: {
      //   default: this.options.allowFullscreen,
      //   parseHTML: () => this.options.allowFullscreen
      // },
      allowfullscreen: {
        default: null,
        parseHTML: () => null
      },
      allow: {
        default: this.options.allowFullscreen ? 'fullscreen' : ''
      },
      style: {
        default: 'position: absolute; width: 100%; height: 100%;'
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-iframe-container] div[data-iframe-wrapper] iframe'
      },
      {
        tag: 'iframe'
      }
    ]
  },

  renderHTML({ HTMLAttributes, node }) {
    //  return ['div', this.options.HTMLAttributes, ['iframe', HTMLAttributes]]
    // return ['div', { class: 'iframe-container' }, ['div', this.options.HTMLAttributes, ['iframe', HTMLAttributes]]]

    console.log('AAAAA iframe renderHTML - HTMLAttributes: ', HTMLAttributes, ' | node: ', node)

    const iframeAttributes = { ...omit(HTMLAttributes, ['customWidth']) }

    return [
      'div',
      // { 'data-iframe-container': '', style: `width: ${HTMLAttributes?.customWidth}%; max-width: 1200px; max-height: auto; margin: 0 auto;` },
      { 'data-iframe-container': '', style: `width: ${HTMLAttributes?.customWidth}%; max-height: auto; margin: 0 auto;` },
      [
        'div',
        {
          'data-iframe-wrapper': '',
          style: 'position: relative; padding-bottom: calc(48.4653% + 42px); height: 0px;'
          // ...this.options.HTMLAttributes
        },
        ['iframe', iframeAttributes]
      ]
    ]
  },

  addCommands() {
    return {
      setIframe:
        (options: { src: string }) =>
        ({ tr, dispatch }) => {
          const { selection } = tr
          const node = this.type.create(options)

          if (dispatch) {
            tr.replaceRangeWith(selection.from, selection.to, node)
          }

          return true
        },
      setIframeWidth: (options: { width: string }) => {
        return stuff => {
          stuff.tr.setNodeAttribute(stuff.state.selection.anchor, 'customWidth', options?.width)

          return true
        }
      }
    }
  }

  // addNodeView() {
  //   return ({ node, editor, getPos }) => {
  //     const {
  //       view,
  //       options: { editable }
  //     } = editor
  //     const { style } = node.attrs
  //
  //     const $wrapper = document.createElement('div')
  //     const $container = document.createElement('div')
  //     const $iframe = document.createElement('iframe')
  //     const iconStyle = 'width: 24px; height: 24px; cursor: pointer;'
  //
  //     const dispatchNodeView = () => {
  //       if (typeof getPos === 'function') {
  //         const newAttrs = {
  //           ...node.attrs,
  //           style: `${$iframe.style.cssText}`
  //         }
  //         view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs))
  //       }
  //     }
  //     const paintPositionContoller = () => {
  //       const $postionController = document.createElement('div')
  //
  //       const $leftController = document.createElement('img')
  //       const $centerController = document.createElement('img')
  //       const $rightController = document.createElement('img')
  //
  //       const controllerMouseOver = e => {
  //         e.target.style.opacity = 0.3
  //       }
  //
  //       const controllerMouseOut = e => {
  //         e.target.style.opacity = 1
  //       }
  //
  //       $postionController.setAttribute(
  //         'style',
  //         'position: absolute; top: 0%; left: 50%; width: 100px; height: 25px; z-index: 999; background-color: rgba(255, 255, 255, 0.7); border-radius: 4px; border: 2px solid #6C6C6C; cursor: pointer; transform: translate(-50%, -50%); display: flex; justify-content: space-between; align-items: center; padding: 0 10px;'
  //       )
  //
  //       $leftController.setAttribute(
  //         'src',
  //         'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_left/default/20px.svg'
  //       )
  //       $leftController.setAttribute('style', iconStyle)
  //       $leftController.addEventListener('mouseover', controllerMouseOver)
  //       $leftController.addEventListener('mouseout', controllerMouseOut)
  //
  //       $centerController.setAttribute(
  //         'src',
  //         'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_center/default/20px.svg'
  //       )
  //       $centerController.setAttribute('style', iconStyle)
  //       $centerController.addEventListener('mouseover', controllerMouseOver)
  //       $centerController.addEventListener('mouseout', controllerMouseOut)
  //
  //       $rightController.setAttribute(
  //         'src',
  //         'https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_right/default/20px.svg'
  //       )
  //       $rightController.setAttribute('style', iconStyle)
  //       $rightController.addEventListener('mouseover', controllerMouseOver)
  //       $rightController.addEventListener('mouseout', controllerMouseOut)
  //
  //       $leftController.addEventListener('click', () => {
  //         $iframe.setAttribute('style', `${$iframe.style.cssText} margin: 0 auto 0 0;`)
  //         dispatchNodeView()
  //       })
  //       $centerController.addEventListener('click', () => {
  //         $iframe.setAttribute('style', `${$iframe.style.cssText} margin: 0 auto;`)
  //         dispatchNodeView()
  //       })
  //       $rightController.addEventListener('click', () => {
  //         $iframe.setAttribute('style', `${$iframe.style.cssText} margin: 0 0 0 auto;`)
  //         dispatchNodeView()
  //       })
  //
  //       $postionController.appendChild($leftController)
  //       $postionController.appendChild($centerController)
  //       $postionController.appendChild($rightController)
  //
  //       $container.appendChild($postionController)
  //     }
  //
  //     $wrapper.setAttribute('style', `display: flex;`)
  //     $wrapper.appendChild($container)
  //
  //     $container.setAttribute('style', `${style}`)
  //     $container.appendChild($iframe)
  //
  //     Object.entries(node.attrs).forEach(([key, value]) => {
  //       if (value === undefined || value === null) return
  //       $iframe.setAttribute(key, value)
  //     })
  //
  //     if (!editable) return { dom: $iframe }
  //
  //     const dotsPosition = [
  //       'top: -4px; left: -4px; cursor: nwse-resize;',
  //       'top: -4px; right: -4px; cursor: nesw-resize;',
  //       'bottom: -4px; left: -4px; cursor: nesw-resize;',
  //       'bottom: -4px; right: -4px; cursor: nwse-resize;'
  //     ]
  //
  //     let isResizing = false
  //     let startX: number, startWidth: number
  //
  //     $container.addEventListener('click', () => {
  //       //remove remaining dots and position controller
  //       if ($container.childElementCount > 3) {
  //         for (let i = 0; i < 5; i++) {
  //           $container.removeChild($container.lastChild as Node)
  //         }
  //       }
  //
  //       paintPositionContoller()
  //
  //       $container.setAttribute('style', `position: relative; border: 1px dashed #6C6C6C; ${style} cursor: pointer;`)
  //
  //       Array.from({ length: 4 }, (_, index) => {
  //         const $dot = document.createElement('div')
  //         $dot.setAttribute(
  //           'style',
  //           `position: absolute; width: 9px; height: 9px; border: 1.5px solid #6C6C6C; border-radius: 50%; ${dotsPosition[index]}`
  //         )
  //
  //         $dot.addEventListener('mousedown', e => {
  //           e.preventDefault()
  //           isResizing = true
  //           startX = e.clientX
  //           startWidth = $container.offsetWidth
  //
  //           const onMouseMove = (e: MouseEvent) => {
  //             if (!isResizing) return
  //             const deltaX = index % 2 === 0 ? -(e.clientX - startX) : e.clientX - startX
  //
  //             const newWidth = startWidth + deltaX
  //
  //             $container.style.width = newWidth + 'px'
  //
  //             $iframe.style.width = newWidth + 'px'
  //           }
  //
  //           const onMouseUp = () => {
  //             if (isResizing) {
  //               isResizing = false
  //             }
  //             dispatchNodeView()
  //
  //             document.removeEventListener('mousemove', onMouseMove)
  //             document.removeEventListener('mouseup', onMouseUp)
  //           }
  //
  //           document.addEventListener('mousemove', onMouseMove)
  //           document.addEventListener('mouseup', onMouseUp)
  //         })
  //         $container.appendChild($dot)
  //       })
  //     })
  //
  //     document.addEventListener('click', (e: MouseEvent) => {
  //       const $target = e.target as HTMLElement
  //       const isClickInside = $container.contains($target) || $target.style.cssText === iconStyle
  //
  //       if (!isClickInside) {
  //         const containerStyle = $container.getAttribute('style')
  //         const newStyle = containerStyle?.replace('border: 1px dashed #6C6C6C;', '')
  //         $container.setAttribute('style', newStyle as string)
  //
  //         if ($container.childElementCount > 3) {
  //           for (let i = 0; i < 5; i++) {
  //             $container.removeChild($container.lastChild as Node)
  //           }
  //         }
  //       }
  //     })
  //
  //     return {
  //       dom: $wrapper
  //     }
  //   }
  // }
})
